import { store } from "./store";

/**
 * Functie voor het reorderen van object met key numbers start altijd bij 1.
 *
 * INPUT {1: {value: 1, optie: 2}: 3: {value: 2, optie: 3}}
 * OUTPUT {1: {value: 1, optie: 2}: 2: {value: 2, optie: 3}}
 *
 */
export function reOrderObjectKeys(inputObj) {
  let outputObj = {};
  let firstid = 1;

  Object.keys(inputObj).map((key) => {
    outputObj[firstid] = inputObj[key];
    firstid++;
  });

  return outputObj;
}

/**
 * Function om text aan te passen op basis van een object
 * input:
 *      neeldes = {id: 10}
 *      haystack = voorbeeld :id
 * Output:  voordeel 10
 */
export function replaceDynamicText(needles, haystack) {
  return Object.keys(needles).reduce((prev, current) => {
    return prev.replace(new RegExp(":" + current, "g"), needles[current]);
  }, haystack);
}

/**
 * Function to validate email
 */
export function verifyEmail(value) {
  var emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
}

/**
 * Function to validate JSON
 */

export function isValidJson(str, emptyIsValid = true) {
  if (emptyIsValid && (str === null || str === "")) {
    return true;
  }

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 *  Get an item from an array using "dot" notation.
 *  Arr: {level1: {level2: {level3: true}}}
 *  key: level1.level2.level3
 *  output: true
 */
export function ArrGet(arr, key) {
  key.split(".").forEach((segment) => {
    arr = arr[segment];
  });

  return arr;
}

/**
 * Standaard format valuta format
 * Kijkt naar de user instellingen
 *
 * @param input value that need to be formated
 * @param forcedCurrency currency forced voor bijvoorbeeld producten formulier. Als je weet wat de valuta is
 * @returns {string}
 */
export function formatValuta(input, forcedCurrency = false) {
  /**
   * Fallback altijd naar euro
   */
  let currency = "EUR";

  if (forcedCurrency !== false && forcedCurrency != null) {
    currency = forcedCurrency;
  } else {
    if (!(store.getState().user.valuta == null)) {
      currency = store.getState().user.valuta;
    }
  }

  const formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(input);
}
